export function headerFunc() {
  // ハンバーガーメニュー実装
  $('.navToggle').on('click', function() {
    $('.navToggle').toggleClass('closeNav');
    $('.header-nav').toggleClass('openNav');
    $('.site-header').toggleClass('openNav');
    $('body').toggleClass('menuOpen');
  });

  $('.header-nav__list a').on('click', function() {
    $('.header-nav').removeClass('openNav');
    $('.navToggle').removeClass('closeNav');
    $('.site-header').removeClass('openNav');
    $('body').removeClass('menuOpen');
  });
}

export function headerScrFunc() {
  const header = document.getElementById('header');
  if (window.scrollY > 50) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
}